<template>
  <div>
    <div
      class="list"
      v-for="(item, index) in data"
      :key="index"
      @click="jumpDetail(item)"
      :clstag="`newscenter|keycount|detail-H5|link-id-${item.id || item.page}`"
    >
      <h3 :class="item.isMark ? 'font-red' : ''">
        <img
          v-if="item.pubTime >= todyTimer"
          src="@/assets/img-m/icon-new.png"
        />
        <span v-html="item.title"></span>
        <!-- <i class="top" v-if="item.top"></i> -->
      </h3>
      <h6>
        {{ $t('来源') }}：{{ item.source || item.from
        }}<span>{{
          (item.pubTime || item.createTime) | dataFilter(true)
        }}</span>
      </h6>
    </div>
  </div>
</template>

<script>
// import jumpDetail from '../mixin/jumpDetail'
export default {
  // mixins: [jumpDetail],
  props: {
    data: Array
  },
  data() {
    return {
      todyTimer: new Date().setHours(0, 0, 0, 0)
    }
  },
  methods: {
    jumpDetail(item) {
      let { contentType, url, contentId, page, otherInfo, cateId } = item
      if (cateId == 'portal') {
        window.location.href = '//www.ciftis.org' + page
      }
      if (otherInfo) otherInfo = JSON.parse(otherInfo)
      contentType = contentType || otherInfo.contentType
      url = url || otherInfo.url
      contentId = contentId || page
      if (contentType == 1) {
        //外链
        window.location.href = url
      } else if (contentType == 5) {
        //富文本
        const opts = {
          url
        }
        this.bus.$emit('showFileDown', opts)
      } else {
        this.$router.push({
          name: 'mobile_detail',
          query: {
            id: contentId
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.list {
  padding: 0.24rem 0.05rem 0.3rem;
  border-bottom: 1px solid $borderColor;
  h3 {
    font-size: 0.32rem;
    color: #333;
    line-height: 0.48rem;
    @include ellipsisMultiline($number: 2);

    img {
      width: 0.7rem;
      margin-right: 0.1rem;
      vertical-align: middle;
    }
  }
  h6 {
    line-height: 0.24rem;
    font-size: 0.24rem;
    padding-top: 0.36rem;
    color: #999;
    span {
      float: right;
    }
  }
}
.font-red {
  color: #e02020 !important;
}
</style>
